export default __webpack_public_path__ + "static/media/sounds/rct_accuracy_model_click_correct.mp3";